<ng-container *ngIf="isButtonVisible">
    <button class="page-heading-right-content btn btn-secondary btn-lg btn-i btn-outline btn-white"
        [class._hasSubtext]="lastSync"
        [disabled]="lastSync && lastSync.status === 'IN_PROGRESS'"
        (click)="syncTruckJourneys()">
        <i class="fa fa-sync-alt"></i>
        <span [i18n]="'truck-journeys.synchronize'"></span>
    </button>
    <br/>
    <span *ngIf="lastSync">
        <div class="lastSync">
            <i class="fa fa-info-circle"></i>
            <ng-container *ngIf="lastSync.status !== 'IN_PROGRESS'">
                <small [i18n]="'truck-journeys.last-synchronization-date'"></small>{{ lastSync.endedAt | fullDate: true: true}}
            </ng-container>
            <small *ngIf="lastSync.status === 'IN_PROGRESS'" [i18n]="'truck-journeys.sync-in-progress'"></small>
        </div>
    </span>
</ng-container>
